export default "__VITE_ASSET__Dccya$n7__"